export const CLASSIC_EAC_URL = process.env.REACT_APP_CLASSIC_EAC_URL || 'https://www3.aia.com.hk/agency';
export const API_GW_KEY = process.env.REACT_APP_API_GW_KEY;
export const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH;
export const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:3003';
export const AEM_HOST = process.env.REACT_APP_AEM_HOST || 'http://localhost:4503';
export const EKMS_URL = process.env.REACT_APP_EKMS_URL || 'https://aiahk-blob01-prd.aia.com.hk/ekms'
export const MOCK_API = process.env.REACT_APP_MOCK === 'true';
export const AIA_ENV = process.env.REACT_APP_AIA_ENV || '';
export const CHATBOT_SDK_HOST = process.env.REACT_APP_CHATBOT_SDK_HOST || 'https://aiahk-apps-sit.aia.com.hk';
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const BUILD_DATE = process.env.BUILD_DATE || new Date().toUTCString();
export const ENV = process.env.NODE_ENV;
export const IHS_HOST = process.env.REACT_APP_IHS_HOST || 'https://agency.aia.com.hk';

